<template>
  <div class="test-page">
    <div class="card">
      <h2>文字分享测试</h2>
      
      <div class="test-section">
        <h3>1. 创建分享</h3>
        <div class="form-group">
          <label for="shareText">文字内容：</label>
          <textarea 
            id="shareText" 
            v-model="shareText" 
            rows="4" 
            placeholder="输入测试文字..."
          ></textarea>
        </div>
        
        <div class="form-group">
          <label for="authorName">作者名称：</label>
          <input 
            type="text" 
            id="authorName" 
            v-model="authorName" 
            placeholder="输入作者名称"
          />
        </div>
        
        <button class="btn btn-primary" @click="generateShareData">
          1. 生成分享数据
        </button>
      </div>
      
      <div class="test-section" v-if="jsonData">
        <h3>2. JSON数据</h3>
        <pre class="code-block">{{ jsonData }}</pre>
        
        <button class="btn btn-primary" @click="encryptData">
          2. 加密数据
        </button>
      </div>
      
      <div class="test-section" v-if="encryptedData">
        <h3>3. 加密后的数据</h3>
        <div class="encrypted-data">
          <p>{{ encryptedData }}</p>
        </div>
        
        <div class="share-url" v-if="shareUrl">
          <h4>分享链接：</h4>
          <input type="text" readonly :value="shareUrl" ref="urlInput" />
          <button class="btn btn-copy" @click="copyShareUrl">复制链接</button>
        </div>
        
        <button class="btn btn-primary" @click="decryptData">
          3. 尝试解密数据
        </button>
      </div>
      
      <div class="test-section" v-if="decryptedData">
        <h3>4. 解密结果</h3>
        <pre class="code-block">{{ decryptedData }}</pre>
        
        <div v-if="parsedData">
          <h4>解析后的JSON：</h4>
          <pre class="code-block">{{ parsedData }}</pre>
        </div>
      </div>
      
      <div class="test-section error-section" v-if="error">
        <h3>错误信息</h3>
        <div class="error-message">{{ error }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import cryptoUtil from '../utils/crypto.js'
import { CRYPTO_CONFIG } from '../utils/config.js'

export default {
  name: 'TestSharePage',
  data() {
    return {
      shareText: '这是一个测试文本，用于验证加密和解密功能是否正常工作。',
      authorName: '测试用户',
      jsonData: null,
      encryptedData: null,
      shareUrl: null,
      decryptedData: null,
      parsedData: null,
      error: null
    }
  },
  methods: {
    generateShareData() {
      try {
        this.error = null
        this.encryptedData = null
        this.decryptedData = null
        this.parsedData = null
        this.shareUrl = null
        
        // 创建要加密的数据对象
        const shareData = {
          text: this.shareText,
          authorName: this.authorName || '匿名用户',
          timestamp: new Date().toISOString()
        }
        
        // 将数据转换为JSON字符串
        this.jsonData = JSON.stringify(shareData, null, 2)
      } catch (error) {
        console.error('生成分享数据失败:', error)
        this.error = '生成分享数据失败: ' + error.message
      }
    },
    
    encryptData() {
      try {
        this.error = null
        this.encryptedData = null
        this.decryptedData = null
        this.parsedData = null
        this.shareUrl = null
        
        if (!this.jsonData) {
          throw new Error('请先生成分享数据')
        }
        
        // 使用配置中的密钥加密数据
        const encryptionKey = CRYPTO_CONFIG.ENCRYPTION_KEY
        console.log('使用的加密密钥:', encryptionKey)
        
        this.encryptedData = cryptoUtil.encrypt(this.jsonData, encryptionKey)
        console.log('加密后的数据:', this.encryptedData)
        
        // 生成分享URL
        const baseUrl = window.location.origin
        this.shareUrl = `${baseUrl}/#/text/${this.encryptedData}`
      } catch (error) {
        console.error('加密数据失败:', error)
        this.error = '加密数据失败: ' + error.message
      }
    },
    
    decryptData() {
      try {
        this.error = null
        this.decryptedData = null
        this.parsedData = null
        
        if (!this.encryptedData) {
          throw new Error('请先加密数据')
        }
        
        // 使用配置中的密钥解密数据
        const encryptionKey = CRYPTO_CONFIG.ENCRYPTION_KEY
        console.log('使用的解密密钥:', encryptionKey)
        
        this.decryptedData = cryptoUtil.decrypt(this.encryptedData, encryptionKey)
        console.log('解密后的数据:', this.decryptedData)
        
        // 尝试解析JSON
        try {
          const parsedData = JSON.parse(this.decryptedData)
          this.parsedData = JSON.stringify(parsedData, null, 2)
        } catch (parseError) {
          console.error('解析JSON失败:', parseError)
          this.error = '解析JSON失败: ' + parseError.message
        }
      } catch (error) {
        console.error('解密数据失败:', error)
        this.error = '解密数据失败: ' + error.message
      }
    },
    
    copyShareUrl() {
      const urlInput = this.$refs.urlInput
      urlInput.select()
      document.execCommand('copy')
      alert('分享链接已复制到剪贴板')
    }
  }
}
</script>

<style scoped>
.test-page {
  display: flex;
  justify-content: center;
  padding: 20px;
}

.card {
  background: white;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 30px;
  width: 100%;
  max-width: 800px;
}

h2 {
  color: #07C160;
  margin-bottom: 30px;
  text-align: center;
}

h3 {
  color: #333;
  margin-bottom: 15px;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}

.test-section {
  margin-bottom: 30px;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 8px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  font-weight: bold;
  margin-bottom: 8px;
  color: #333;
}

textarea, input[type="text"] {
  width: 100%;
  padding: 12px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  font-size: 16px;
  font-family: inherit;
}

.code-block {
  background-color: #f0f0f0;
  padding: 15px;
  border-radius: 4px;
  font-family: monospace;
  white-space: pre-wrap;
  word-break: break-word;
  margin: 10px 0 20px;
  font-size: 14px;
  max-height: 200px;
  overflow-y: auto;
}

.encrypted-data {
  background-color: #fff;
  padding: 15px;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  margin-bottom: 20px;
  word-break: break-all;
}

.share-url {
  margin: 20px 0;
}

.share-url h4 {
  margin-bottom: 10px;
}

.share-url input {
  width: calc(100% - 100px);
  padding: 10px;
  border: 1px solid #e0e0e0;
  border-radius: 4px 0 0 4px;
  font-size: 14px;
}

.btn {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s;
}

.btn-primary {
  background-color: #07C160;
  color: white;
  display: block;
  margin: 20px auto 0;
}

.btn-copy {
  background-color: #07C160;
  color: white;
  border-radius: 0 4px 4px 0;
  padding: 10px;
  font-size: 14px;
}

.error-section {
  background-color: #fff8f8;
  border: 1px solid #ffebeb;
}

.error-message {
  color: #ff4d4f;
  padding: 10px;
  background-color: #fff0f0;
  border-radius: 4px;
}
</style>